import React from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
import { withTheme } from 'styled-components/macro';

const PieProspectChart = ({ categories }) => {
  if (!categories || categories.length === 0) return null;

  const labels = categories.map((cat) => cat.title);
  const dataValues = categories.map((cat) => cat.total); 
  const colors = categories.map((cat) => cat.color);

  const data = {
    labels,
    datasets: [
      {
        data: dataValues,
        backgroundColor: colors,
        borderColor: colors,
        borderWidth: 1,
      },
    ],
  };

  const options = {
    legend: {
      display: false,
    },
    tooltip: {
      display: false,
    },
    maintainAspectRatio: false,
    cutoutPercentage: 75,
    responsive: true,
  };

  return <Doughnut data={data} options={options} />;
};

export default withTheme(PieProspectChart);
